import { ADD_CLIENT, QUOTE_DATA_MODAL, SAVE_ACTIVE_PRODUCT_CODE, UPDATE_CLIENT, saveACtiveProductCode } from "./actions";

const initialState = {
  policy: {
    client: {},
    quoteDataModal: {}
  },
  activeProductCode: 'IG'
};

const quoteReducer = (state = initialState, action) => {
  const { type, client, otherDataClient, quoteDataModal, saveActiveProductCode } = action;

  switch (type) {
    case ADD_CLIENT:
      return { ...state, policy: { ...state.policy, client } };
    case UPDATE_CLIENT:
      const updateClient = {
        ...state.policy.client.datosCliente,
        ...otherDataClient,
      };
      return {
        ...state,
        policy: {
          ...state.policy,
          client: { ...state.policy.client, datosCliente: updateClient },
        },
      };
    case QUOTE_DATA_MODAL:
      return { ...state, policy: { ...state.policy, quoteDataModal } };
    case SAVE_ACTIVE_PRODUCT_CODE:
      return { ...state, activeProductCode: saveActiveProductCode }
    default:
      return state;
  }
};

export default quoteReducer;
